import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { UpdateMeetingFlexibilityDocument } from "../../flexible-meeting-suggestions-control/graphql/__generated__/UpdateMeetingFlexiblity.v2.generated";

export const useToggleFlexibility = (externalEventId: string) => {
  const [editEventFlexibility, { loading: updating, error: updateError }] = useGatewayMutation(
    UpdateMeetingFlexibilityDocument,
  );

  const update = async ({
    variables: { toggleToOn },
    onCompleted,
    onError,
  }: {
    variables: { toggleToOn: boolean };
    onCompleted?: () => void;
    onError?: () => void;
  }) => {
    await editEventFlexibility({
      variables: {
        events: [
          {
            externalEventId,
            isFlexible: toggleToOn,
          },
        ],
      },
      onCompleted,
      onError,
    });
  };

  return {
    update,
    updating,
    updateError,
  };
};
